import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';

export const Beta = ({ children, ...props }: BoxProps) => (
    <Box component="span" {...props}>
        {children}
        <Box
            //component="span"
            sx={{
                fontSize: 7,
                display: 'inline-block',
                //verticalAlign: children ? 'text-bottom' : 'text-top',
                transform: 'translateY(-7px)',
                ml: 1,
            }}
        >
            BETA
        </Box>
    </Box>
);
